import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0001 16L8.05847 13.7496C5.09206 13 3.33543 10.5129 3.95943 7.75C3.95943 7.75 4.62073 4 10.0001 4C15.3795 4 16.0408 7.75 16.0408 7.75C16.6648 10.5129 14.9082 13 11.9418 13.7496L10.0001 16Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgSupport;
